import { IconType } from "./types";

export const ArrowBackIcon = ({ scale = 1, color = "white" }: IconType) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      scale={scale}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.387627 6.38763C0.0494232 6.72583 0.0494232 7.27417 0.387627 7.61237L5.89898 13.1237C6.23718 13.4619 6.78552 13.4619 7.12372 13.1237C7.46193 12.7855 7.46193 12.2372 7.12372 11.899L2.22474 7L7.12372 2.10102C7.46193 1.76282 7.46193 1.21448 7.12372 0.876276C6.78552 0.538072 6.23718 0.538072 5.89898 0.876276L0.387627 6.38763ZM19 6.13397L1 6.13397V7.86603L19 7.86603V6.13397Z"
        fill={color}
      />
    </svg>
  );
};
